module.exports = __webpack_public_path__ + "static/media/12.0a469b91.jpg";